module.exports = __webpack_public_path__ + "static/media/641.85d089aa.webp";